/* eslint-disable react/prop-types */
import React, { useState } from "react";

import { toast } from "react-toastify";
import axios from "axios";
import { DatePicker } from "react-patro";

import { format } from "date-fns";
import "date-fns";

const label = { inputProps: { "aria-label": "Switch demo" } };

const EditClient = (props) => {
  console.log(props.data)
    const _data = props.data;
 
  const [date1, setDate1] = useState();
  const [companyName, setCompanyName] = useState(_data.companyName);
  const [clientName, setClientName] = useState(_data.companyName);
  const [representative, setRepresentative] = useState();
  const [totalPc, setTotalPc] = useState(_data.totalPc);
  const [address, setAddress] = useState(_data.address);
  const [contactNo, setContactNo] = useState(_data.contactNo);
  const [licenseDate, setLicenseDate] = useState();
  const [expireDate, setExpireDate] = useState();
  const [macAddress, setMacAddress] = useState();
  const [installDate, setInstallDate] = useState(Date.now());


  const handleSubmission = (e) => {
    e.preventDefault();
    
    let req_value = {
      companyId: _data.id,
      companyName:companyName,
      address:address,
      contactNo:contactNo,
      clientName: clientName,
   

      expireDate: format(new Date(expireDate), "yyyy-MM-dd").toString(),
    };
    props.handleSubmit(req_value);
  };

  return (
    <div className="EditForm p-3">
      <div className="data-table-info">
        <h4 className="data-table-title">Edit Company</h4>
      </div>
      <div className="row">
        <div className="col-sm-4">
          <label>Company Name</label>
          <input
            type="text"
            className="form-control"
            name="companyName"
            value={companyName}
            onChange={(e) => {
              setCompanyName(e.target.value);
            }}
          />
        </div>
        <div className="col-sm-4">
          <label>Client Name</label>
          <input
            type="text"
            className="form-control"
            name="clientName"
            value={clientName}
            onChange={(e) => {
              setClientName(e.target.value);
            }}
          />
        </div>
        <div className="col-sm-4">
          <label> Representative</label>
          <input
            type="text"
            className="form-control"
            name="representative"
            value={representative}
            onChange={(e) => {
              setRepresentative(e.target.value);
            }}
          />
        </div>
        <div className="col-sm-4">
          <label> Total Pc</label>
          <input
            type="number"
            className="form-control"
            name="totalPc"
            value={totalPc}
            disabled
          />
        </div>
        <div className="col-sm-4">
          <label> Address</label>
          <input
            type="text"
            className="form-control"
            name="address"
            value={address}
            onChange={(e) => {
              setAddress(e.target.value);
            }}
          />
        </div>
        <div className="col-sm-4">
          <label> Contact No.</label>
          <input
            type="text"
            className="form-control"
            name="contactNo"
            value={contactNo}
            onChange={(e) => {
              setContactNo(e.target.value);
            }}
          />
        </div>
        {/* <div className="col-sm-4">
          <label> MAC Address</label>
          <input
            type="text"
            className="form-control"
            value={macAddress}
            onChange={(e) => {
              setMacAddress(e.target.value);
            }}
            disabled
          />
        </div>
        <div className="col-sm-4">
          <label>Install Date </label>
          <input
            type="text"
            className="form-control"
            value={installDate}
            disabled
          />
        </div>
        <div className="col-sm-4">
          <label>License Date </label>
          <input
            type="text"
            className="form-control"
            name='licenseDate'
            value={licenseDate}
            disabled
          />
          
        </div>
        <div className="col-sm-4">
          <label>Expire Date </label>
          <DatePicker
          name="date"
          value={expireDate}
          onChange={(e) => {
              setExpireDate(e.target.value);
          }}
          />
        </div> */}

        <div
          className="col-sm-12 submitBtn  mt-3 "
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <button
            type="submit"
            className="btn btn-success mx-2"
            onClick={handleSubmission}
          >
            Submit
          </button>
          <button
            type="submit"
            className="btn btn-danger mx-2"
            onClick={() => props.setIsEdit(false)}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditClient;
